import axios from 'axios'
import Config from '../config/config.js';
import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import * as Types from './mutation-types'
import Cookie from 'js-cookie'

// axios 配置
axios.defaults.timeout = 5000
axios.defaults.baseURL = Config.baseUrl
axios.defaults.headers['spl-token'] = Cookie.get('spl_token');

Vue.use(Vuex);

const state = localStorage.getItem('state') ? JSON.parse(localStorage.getItem('state')) : {
    user: null,
    cart: [],
    isLogin: false,
    delFlag: false,
    userTypeNum: '',
    checkAllFlag: false,
};
state.player = null;
state.newAddGoodsNum = 0;
state.timer='空'

const store = new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js